<template lang="html">
  <section class="blog-el">
    <router-link
          :to="`/blog/` + slug">
    <div class="box-blog">
      <div class="img" :style="`background-image:url(` + imageUrl + `)`"></div>
      <div class="content">
        <p class="title">{{ title }}</p>
        <p class="date">{{currentDateTime(date) }}</p>
        <div class="description">
          <p>
            {{ description }}
          </p>
        </div>
        <span
          class="link-btn"
        ></span>
      </div>
    </div>
    </router-link>
  </section>
</template>

<script lang="js">

  import {mapGetters} from 'vuex';
  import moment from 'moment'
  export default  {
    name: 'blog-el',
    props: ['data','imageUrl','title','description','slug','date'],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {
    currentDateTime(date) {
      return moment(date).locale('es').format('LL')
    },
    },
    computed: {
      ...mapGetters({
        lang : 'getLanguage'
      })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/parts/blog-el.vue